import {FC, useState} from "react";
import IconLogin from "../../assets/icons/log-in.svg";
import IconLogOut from "../../assets/icons/log-out.svg";
import {ImgIconWrapper, ToggleBtnPanel} from "./styles";
import {Tooltip} from "react-tooltip";
import {AuthPage} from "../../auth/AuthPage";
import {LogOutPage} from "../../auth/LogOutPage";
import {useAuthStatus} from "../../hooks/useAuthStatus";

interface IProps {
  setIsLogin?: React.Dispatch<React.SetStateAction<boolean>>;
  setRole?: React.Dispatch<React.SetStateAction<string | null>>;
  isOpenPanel: boolean;
}

export const BtnAuth: FC<IProps> = ({setIsLogin, setRole, isOpenPanel}) => {
  const [isOpenAuthModal, setIsOpenAuthModal] = useState(false);
  const [isOpenLogoutModal, setIsOpenLogoutModal] = useState(false);
  const [isAuth, setIsAuth, roleAuth, setRoleAuth] = useAuthStatus([
    isOpenAuthModal,
  ]);

  setIsLogin?.(isAuth);
  setRole?.(roleAuth);

  const handleLogout = () => {
    localStorage.removeItem("jwtRadar");
    localStorage.removeItem("roleRadar");
    localStorage.removeItem("userIdRadar");
    window.dispatchEvent(new CustomEvent("authChanged"));
    setIsAuth(false);
    setIsLogin?.(false);
    setRoleAuth?.(null);
    setRole?.(null);
    setIsOpenLogoutModal(false);
  };
  return (
    <>
      <ToggleBtnPanel
        isactive={isOpenPanel.toString()}
        data-tooltip-id={`settings`}
        data-tooltip-content={isAuth ? "Выйти" : "Войти"}
        addstyle={"padding-left:8px"}
        onClick={() => {
          if (isAuth) {
            setIsOpenLogoutModal(true);
          } else {
            setIsOpenAuthModal(true);
          }
        }}
      >
        <ImgIconWrapper isrotate="true">
          <img
            src={isAuth ? IconLogOut : IconLogin}
            alt="Mail"
            width="22"
            height="22"
          />
        </ImgIconWrapper>
        <span>{isAuth ? "Выйти" : "Войти"}</span>
        {!isOpenPanel && (
          <Tooltip id={"settings"} place="right" className="tooltip" noArrow />
        )}
      </ToggleBtnPanel>

      <AuthPage
        isOpenAuthModal={isOpenAuthModal}
        onCloseModal={() => setIsOpenAuthModal(false)}
      />
      <LogOutPage
        isOpenAuthModal={isOpenLogoutModal}
        onCloseModal={() => setIsOpenLogoutModal(false)}
        onLogout={handleLogout}
      />
    </>
  );
};
